module.exports = __webpack_public_path__ + "img/6-2.d0ffd45c.jpg";